import { useAppStore } from '../../GlobalStore/GlobalStore';
import { QueuedMessage } from '../../GlobalStore/Slices/DynamicStateObjSlice';
import { v4 as uuidv4 } from 'uuid';

export const useMessageQueue = () => {
    const messageQueue = useAppStore((state: any) => state.dynamicStateObj.messageQueue);
    const updateMessageQueue = useAppStore((state: any) => state.updateMessageQueue);

    const enqueueMessage = (text: string, files: Record<string, any>, isImportant: boolean = false) => {
        const queuedMessage: QueuedMessage = {
            id: uuidv4(),
            text,
            files,
            timestamp: Date.now(),
            isImportant
        };
        updateMessageQueue(queuedMessage, 'add');
        return queuedMessage.id;
    };

    const dequeueMessage = (): QueuedMessage | undefined => {
        if (messageQueue.length === 0) return undefined;
        
        const message = messageQueue[0];
        updateMessageQueue(message.id, 'remove');
        return message;
    };

    const removeMessage = (id: string) => {
        updateMessageQueue(id, 'remove');
    };

    const reorderMessage = (fromIndex: number, toIndex: number) => {
        updateMessageQueue({ fromIndex, toIndex }, 'reorder');
    };

    const clearQueue = () => {
        updateMessageQueue(null, 'clear');
    };

    const getQueueSize = () => messageQueue.length;

    const isQueueEmpty = () => messageQueue.length === 0;

    const getNextMessage = (): QueuedMessage | undefined => {
        return messageQueue[0];
    };

    return {
        messageQueue,
        enqueueMessage,
        dequeueMessage,
        removeMessage,
        reorderMessage,
        clearQueue,
        getQueueSize,
        isQueueEmpty,
        getNextMessage
    };
};